module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0001-9057e399a48d044f2ff1cc504def0513.jpg";